import {
    ReviewModalWidgetV2,
    useReviewContext,
} from '@reconvert/review-collector-ui';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from '../../app/hooks';
import { selectAppState } from '../../app/slice/appSlice';
import { redirect } from '../../utils/reviewModalRedireact';
import { useMediaQuery } from '@chakra-ui/react';

function ReviewCollectorModalV2() {
    const { isVisible, showThanksForWidget } = useReviewContext();
    const { t } = useTranslation();
    const { isEligibleForReview } = useAppSelector(selectAppState);
    const isMobileView = useMediaQuery('(max-width: 768px)')[0];

    const WIDGET_NAME = 'MODAL_WIDGET_V2';

    return (
        <>
            {isEligibleForReview && (isVisible || showThanksForWidget === WIDGET_NAME) ? (
                <ReviewModalWidgetV2
                    title={isMobileView ? t("How's your experience so far?") : t('How would you rate your experience so far?')}
                    widgetName={WIDGET_NAME}
                    page={"flow builder help"}
                    redirect={() => Promise.resolve(redirect())}
                    closeButton={t('Not now')}
                    submitButtonText={t("Submit")}
                    thankyouMessage={t('Thank you!')}
                    isMobileView={isMobileView}
                    isEditorPage
                />
            ) : null}
        </>
    );
}

export default ReviewCollectorModalV2;
